import script from "./SoundChart.vue?vue&type=script&setup=true&lang=js"
export * from "./SoundChart.vue?vue&type=script&setup=true&lang=js"

import "./SoundChart.vue?vue&type=style&index=0&id=2f055bb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f055bb8"]])

export default __exports__